// extracted by mini-css-extract-plugin
export default {"pagination-wrap":"pw1jM7UFXSw9Xy089Ks0","load-more-purple":"AOKWXyGDNvDmVQp_Sqtr","pagination-pc":"v8HeIEgLrXPXhyRHsJlk","pagination-m":"Uv57Zs6DgyaQJpyVA_Sf"};